import { IObjektVy } from '../../../../../Types/ObjektVy';
import { standardVy } from '../../../../../Utils/ObjektVyUtils';
import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjectVySida';
import { objektVyGrupp } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyGrupp';
import faltVy from '../../../_Common/Components/BusinessCollectionComponents/faltVy';
import FakturaDokOkjektVyComp from './Components/FakturaDokObjektVyComp';

const forstaSida: IObjektVy = ObjektVySida(
  'forstaSida',
  [
    [
      objektVyGrupp(
        'Dokumentinfo',
        [
          faltVy('BESKRIVNING', 'ownblock'),
          faltVy('EXTENSION', 'ownblock'),
          faltVy('SENAST_ANDRAD', 'ownblock'),
          faltVy('SENAST_ANDRAD_SIGNATUR', 'ownblock'),
        ],
        ''
      ),
    ],
  ],
  1,
  'Dokumentinformation'
);

const FakturaDokOkjektVy: IObjektVy = {
  type: 'ObjektVy',
  id: 'Document',
  info: { fullscreenInSideBySide: true },
  def: () => FakturaDokOkjektVyComp,
};

export const standard: IObjektVy = standardVy(
  [
    forstaSida,
    ObjektVySida(
      'Fakturadokument',
      FakturaDokOkjektVy,
      2,
      'Dokument',
      undefined,
      true
    ),
  ],
  { sidaVidSida: true, sideBySideWidths: [5, 7] }
);

export const FakturaDokVyer: IObjektVy[] = [standard];
